"use client";

import { c as _c } from "react/compiler-runtime";
import type { FUSportsLivescoreEvent, SearchEntityResult } from "fansunited-data-layer";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { PeriodsMatchRow } from "./PeriodsMatchRow";
interface HockeyMatchRowProps {
  event: FUSportsLivescoreEvent;
  entities: Record<string, SearchEntityResult>;
}
export function HockeyMatchRow(t0) {
  const $ = _c(4);
  const {
    event,
    entities
  } = t0;
  const labels = useLabels();
  let t1;
  if ($[0] !== entities || $[1] !== event || $[2] !== labels.livescore.period) {
    t1 = <PeriodsMatchRow event={event} entities={entities} sport="hockey" periodLabel={labels.livescore.period} maxRegulationPeriods={3} />;
    $[0] = entities;
    $[1] = event;
    $[2] = labels.livescore.period;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}